function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  id: "Group_1164",
  "data-name": "Group 1164",
  transform: "translate(-286.778 -131.333)"
}, /*#__PURE__*/React.createElement("circle", {
  id: "Ellipse_9",
  "data-name": "Ellipse 9",
  cx: 1.762,
  cy: 1.762,
  r: 1.762,
  transform: "translate(296.548 150.427)",
  fill: "#ff0"
}), /*#__PURE__*/React.createElement("circle", {
  id: "Ellipse_10",
  "data-name": "Ellipse 10",
  cx: 1.762,
  cy: 1.762,
  r: 1.762,
  transform: "translate(303.811 150.427)",
  fill: "#ff0"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_119",
  "data-name": "Path 119",
  d: "M287.778,132.333h3.859l3.508,15.436h12.98l2.719-10.875h-14.3",
  fill: "none",
  stroke: "#ff0",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 2
}));

var SvgShoppingCartYellow = function SvgShoppingCartYellow(_ref) {
  var svgRef = _ref.svgRef,
      props = _objectWithoutProperties(_ref, ["svgRef"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25.066,
    height: 22.618,
    viewBox: "0 0 25.066 22.618",
    ref: svgRef
  }, props), _ref2);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgShoppingCartYellow, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/shopping-cart-yellow.a8bc4b65.svg";
export { ForwardRef as ReactComponent };